export default __webpack_public_path__ + "static/media/papelzinho.12a7e14f.svg";